import axios from "axios";
import { WEB_ROUTES } from "../WebEncryption";


export interface NotificationPreferences {
  inAppEnabled: boolean;
  smsEnabled: boolean;
  emailEnabled: boolean;

  accountLinkingEnabled: boolean;
  consentApprovedEnabled: boolean;
  consentRevokedEnabled: boolean;
  consentPauseResumeEnabled: boolean;
  dataFetchEnabled: boolean;

  fiuSummaryFrequency:
    | "MONTHLY"
    | "FORTNIGHTLY"
    | "WEEKLY"
    | "DAILY";
}

export function getUser() {
  return axios.get(`/User`);
}

export function updateUser(firstName: string, lastName: string) {
  return axios.put(WEB_ROUTES.updateUser, { firstName, lastName });
}

export function updateUserWithNotification(payload: {
  firstName: string;
  lastName: string;
  email: string;
  // sendNotification: boolean;
}) {
  return axios.put(WEB_ROUTES.updateUser, payload);
}

export function updatePin(oldPin: string, newPin: string) {
  return axios.put(WEB_ROUTES.updatePin, { oldPin, newPin });
}

export function deleteUsersLinkedDevice() {
  return axios.post(`/User/delete/linked/device`);
}

export function updateUserNotificationPrefrances(payload: object){
  return axios.post(`/User/update/notification-preferences`, payload);
}

export function getUserNotificationPrefrances() {
  return axios.get(`/User/notification-preferences`);
}
